import React, { useEffect, useState, useRef } from 'react';
import { getHPTs, getPTWs, getPTWStats } from '../api/dashboardService'; // Peticiones al backend
import { logout, cambiarPassword } from '../api/authService'; // Cierre de Sesion y borrado de token. Redirección
import { useNavigate } from 'react-router-dom';
import '../styles/HptScreens.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import SignaturePad from '../components/SignaturePad';

// BackEnd de Serveless
const API_URL = process.env.REACT_APP_API_URL;

// ============================================================================
// COMPONENTE PRINCIPAL: DashboardScreen
// ============================================================================
const DashboardScreen = () => {
    // --- ESTADOS DE DATOS ---
    //const [ptws, setPtws] = useState([]);   // Lista de todos los Permisos de Trabajo
    const [hpts, setHpts] = useState([]);   // Lista de todas las Hojas de Planificación
    //const [totalAnual, setTotalAnual] = useState(0); // Estadística extra (SIN USO)

    
    
    // --- ESTADOS DE NAVEGACIÓN Y MENÚS ---
    const [menuOpen, setMenuOpen] = useState(false);         // Menú tipo hamburguesa
    const [userMenuOpen, setUserMenuOpen] = useState(false); // Menú de usuario
    const [showPendingList, setShowPendingList] = useState(false); // Control de mini-lista de varias firmas pendientes.
    const [showProfile, setShowProfile] = useState(false); // Menu Vista Perfil
    const [showChangePass, setShowChangePass] = useState(false); // Control Vista Cambio Contraseña

    // --- ESTADOS DEL FORMULARIO DE CONTRASEÑA ---
    const [passwords, setPasswords] = useState({ actual: '', nueva: '', confirmacion: '' });
    const [passMsg, setPassMsg] = useState({ error: '', success: '' });
    
    // --- ESTADOS DE BÚSQUEDA EN VIVO ---
    const [searchPTW, setSearchPTW] = useState(''); // Texto escrito en buscador PTW
    const [searchHPT, setSearchHPT] = useState(''); // Texto escrito en buscador HPT
    const [filterGroup, setFilterGroup] = useState(''); // Para Filtrar por Grupo

    // --- ESTADOS DE LAS FIRMAS GUARDADAS ---
    const [firmaGuardada, setFirmaGuardada] = useState(null);
    const [showSignaturePad, setShowSignaturePad] = useState(false);

    // Referencia CLICKS Fuera de Menus
    const menuRef = useRef(null);
    const userRef = useRef(null);
    const navigate = useNavigate();

    // --- ESTADO PARA DESPLEGABLE DE CONTEO ---
    const [showHptCounts, setShowHptCounts] = useState(false);
    const counterHptRef = useRef(null);

    

    // Para control del banner de firmas pendientes.
    let currentUser = {};
    const token = localStorage.getItem('userToken');
    if (token) {
        try {
            currentUser = JSON.parse(atob(token.split('.')[1]));
        } catch(e) {
            console.error("Error leyendo token");
        }
    }

    // Planta seleccionada para Operar
    const [plantaActiva, setPlantaActiva] = useState(() => {
        return currentUser?.plantas?.[0]?.id_planta || '';
    });

    // Datos del usuario logueado sacados del almacenamiento local (creados al hacer Login)
    const nameUser = currentUser.user ||'Usuario';
    const userRol = currentUser.rol;

    // Si no están en localStorage, caemos de vuelta a leerlos del Token decodificado
    const uGrupo = currentUser.grupo;
    const uId = parseInt(currentUser.id);

    const perfilUsuario = {
        usuario: currentUser.user || nameUser,
        nombre: currentUser.user_name || '',
        apellidos: currentUser.user_apelli || '',
        correo: currentUser.user_correo || 'No especificado',
        rol: userRol || 'No asignado',
        grupo: uGrupo || 'No asignado',
        plantas : currentUser.plantas,
    };

    
    // Fecha de hoy formateada como texto "YYYY-MM-DD"
    const hoy = new Date().toISOString().split('T')[0];

    // ============================================================================
    // EFECTOS DE ARRANQUE
    // ============================================================================
    useEffect(() => {
        // Carga de los datos del Dhasboard
        const fetchData = async () => {
            //Modificacion para listado de HPTS pendientes firmas
            const token = localStorage.getItem('userToken');
            const config = { headers: { Authorization: `Bearer ${token}` } };
            if(!plantaActiva) return;
            try {
                //Traemos lista completa enriquecida
                const listaCompleta = await getHPTs(plantaActiva);
                //Guardamos las HPTS en nuestro set.
                setHpts(listaCompleta);
            } catch (err) { console.error("Error en carga:", err); }
        };
        fetchData();
        fetchFirmaUsuario();

        // LÓGICA DE MENÚS: Cierre menus despolegables si se hace click fuera
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) setMenuOpen(false);
            if (userRef.current && !userRef.current.contains(event.target)) setUserMenuOpen(false);
            if (counterHptRef.current && !counterHptRef.current.contains(event.target)) setShowHptCounts(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        
        // Limpiamos el listener cuando se cierra menus para no saturar.
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [plantaActiva]);


    // ============================================================================
    // LÓGICA de banner de Pdt Firmar
    // ============================================================================
    const meTocaFirmar = (hpt) => {
        if (!hpt || hpt.pendiente_de === "COMPLETO") return false;

        const paso = hpt.pendiente_de;

        const creadorEsElectrico = ['ELECTRICOS','SPElectrico'].includes(hpt.creador_grupo);
        const creadorEsMecanico = ['MECANICO','SPMecanico'].includes(hpt.creador_grupo);
        const creadorEsInstrumentacion = ['INSTRUMENTACION', 'SPInstrumentacion'].includes(hpt.creador_grupo);
        const creadorEsCampoSolar = ['CAMPO SOLAR', 'SPCampoSolar'].includes(hpt.creador_grupo);
        const creadorEsQuimico = ['QUIMICO', 'SPQuimico'].includes(hpt.creador_grupo);


        // Los Administradores siempre pueden firmar por cualquiera
        if (userRol === 'ADMINISTRADOR') return true;  

        switch (paso) {
            case 'SOLICITANTE':
                // Si el creador es del mismo grupo
                if (hpt.creador_grupo === uGrupo) return true;
                // Si es creado en el Departamento de Operación puede firmar cualquiera del departamento
                if (
                    ((hpt.creador_grupo === 'JEFE_TURNO') || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || (hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION')) && 
                    (uGrupo === 'JEFE TURNO' || (userRol === 'GESTOR' || uGrupo === 'Operacion') || (userRol === 'OFICIAL' && uGrupo === 'OPERACION'))
                ) return true;
                // Si es creador en el Departamento de Mantenimiento puede firmar Oficiales de Su grupo o Responsables directos.
                if (
                    (creadorEsElectrico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                    ((userRol === 'GESTOR' && uGrupo === 'Mantenimiento') || (userRol === 'OFICIAL' && (uGrupo === 'ELECTRICOS')) || userRol === 'SUPERVISOR')
                ) return true;
                if (
                    (creadorEsMecanico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                    ((userRol === 'GESTOR' && uGrupo === 'Mantenimiento') || (userRol === 'OFICIAL' && (uGrupo === 'MECANICO')) || userRol === 'SUPERVISOR')
                ) return true;
                if (
                    (creadorEsInstrumentacion || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                    ((userRol === 'GESTOR' && uGrupo === 'Mantenimiento') || (userRol === 'OFICIAL' && (uGrupo === 'INSTRUMENTACION')) || userRol === 'SUPERVISOR')
                ) return true;
                if (
                    (creadorEsCampoSolar || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                    ((userRol === 'GESTOR' && uGrupo === 'Mantenimiento') || (userRol === 'OFICIAL' && (uGrupo === 'CAMPO SOLAR')) || userRol === 'SUPERVISOR')
                ) return true;
                if (
                    (creadorEsQuimico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') || hpt.creador_rol === 'SUPERVISOR') && 
                    ((userRol === 'GESTOR' && uGrupo === 'Mantenimiento') || (userRol === 'OFICIAL' && (uGrupo === 'QUIMICO')) || userRol === 'SUPERVISOR')
                ) return true;

                return false;

            case 'RESP_SUBCONTRATA':
                // Si la persona logueada es el RESP_SUBCONTRATA INDICADO
                if (hpt.id_usuario_subcontrata && uId === hpt.id_usuario_subcontrata) return true;
                // Jefe TURNO puede firmar, si la creo él mismo o el Responsable de Operación u Oficial Operacion
                if (userRol === 'JEFE_TURNO' && 
                    (hpt.creador_rol === 'JEFE_TURNO' || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') || (hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION'))
                ) return true;
                // Si es un oficial, puede firmar si pertenece a su grupo o si la creo el supervisor de su grupo o la creo el Responsable de Mantenimiento.
                if (userRol === 'OFICIAL' && 
                    (uGrupo === hpt.creador_grupo || (creadorEsMecanico && uGrupo === 'MECANICO') || (creadorEsElectrico && uGrupo === 'ELECTRICOS') || (creadorEsInstrumentacion && uGrupo === 'INSTRUMENTACION')  || (creadorEsCampoSolar && uGrupo === 'CAMPO SOLAR')  || (creadorEsQuimico && uGrupo === 'QUIMICO')  || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento'))
                ) return true; 
                return false;

            case 'PREVENCION':
                // Solo Prevencion o Responsables de Operacion o Mantenimiento pueden firmar este apartado
                if (userRol === 'PREVENCION' || userRol === 'GESTOR') return true;
                return false;

            case 'SUPERVISOR':
                // Lógica de Responsable (Mantenimiento)
                if (
                    userRol === 'GESTOR' && uGrupo === 'Mantenimiento' && 
                    (creadorEsMecanico || creadorEsElectrico || creadorEsCampoSolar || creadorEsInstrumentacion || creadorEsQuimico || hpt.creador_rol === "SUPERVISOR" || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento'))
                ) return true;
                
                // Lógica de Responsable (Operacion)
                if(
                    userRol === 'GESTOR' && uGrupo === 'Operacion' && 
                    (hpt.creador_rol === "JEFE_TURNO" || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Operacion') ||(hpt.creador_rol === 'OFICIAL' && hpt.creador_grupo === 'OPERACION'))
                ) return true;
                
                // Si el logueado es SUPERVISOR, solo firma si es del mismo departamento
                if (userRol === 'SUPERVISOR') {
                    if (creadorEsMecanico || creadorEsElectrico || creadorEsCampoSolar || creadorEsInstrumentacion || creadorEsQuimico || (hpt.creador_rol === 'GESTOR' && hpt.creador_grupo === 'Mantenimiento') ||  hpt.creador_rol === 'SUPERVISOR') return true;
                }
                return false;

            case 'JEFE_TURNO':
                // Última firma: Exclusiva del Jefe de Turno o responsable de Operación
                return userRol === 'JEFE_TURNO' || (userRol === 'GESTOR' && uGrupo === 'Operacion');

            default:
                return false;
        }
    };

        // ============================================================================
    // FUNCION: BORRAR HPT (Solo Administrador y Gestor)
    // ============================================================================
    const handleDeleteHPT = async (idHpt, otReferencia) => {
        const confirm = await Swal.fire({
            title: '¿Eliminar Planificación?',
            text: `Estás a punto de borrar permanentemente la HPT de la OT: ${otReferencia}. Esta acción no se puede deshacer y borrará también sus documentos adjuntos.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d32f2f',
            cancelButtonColor: '#999',
            confirmButtonText: 'Sí, borrar definitivamente',
            cancelButtonText: 'Cancelar'
        });

        if (confirm.isConfirmed) {
            try {
                const token = localStorage.getItem('userToken');
                await axios.delete(`${API_URL}/api/hpt/${idHpt}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                // Quitamos la HPT borrada del estado actual
                setHpts(prevHpts => prevHpts.filter(h => h.id_hpt !== idHpt));
                
                Swal.fire({
                    title: '¡Borrado!',
                    text: 'La planificación ha sido eliminada del sistema.',
                    icon: 'success',
                    confirmButtonColor: '#003366',
                    timer: 2000
                });
            } catch (error) {
                console.error("Error al borrar HPT:", error);
                Swal.fire({
                    title: 'Error',
                    text: error.response?.data?.error || 'No se pudo eliminar la planificación.',
                    icon: 'error',
                    confirmButtonColor: '#003366'
                });
            }
        }
    };

    // ============================================================================
    // LÓGICA DE CONTEOS Y ESTADÍSTICAS
    // ============================================================================
    //const ptwsTotalCount = ptws.length;
    //const ptwsNoCerradosCount = ptws.filter(p => p.estado !== 'cerrado').length;

    const hptsTotalCount = hpts.length;
    const hptsNoFinalizadasCount = hpts.filter(h => h.fecha_prevista && h.fecha_prevista > hoy).length;

    // ============================================================================
    // LÓGICA DE BUSCADORES INTELIGENTES
    // ============================================================================
    
    // Lista de PTWs a mostrar
    //const ptwsParaMostrar = searchPTW 
        // Si hay búsqueda: FIltro por ID, con un máximo de 10
    //    ? ptws.filter(p => p.id_ptw_formato.toLowerCase().includes(searchPTW.toLowerCase())).slice(0, 10)
        // Si no hay busqueda muestra los últimos 5, que no esten cerrados
    //    : ptws.filter(p => p.estado !== 'cerrado').slice(0, 5);

    // -- Antiguo --
    // Lista de HPTs a mostrar
    //const hptsParaMostrar = searchHPT
        // Si hay búsqueda: Filtra por Orden de Trabajo (OT) máximo de 8
        //? hpts.filter(h => h.ot_referencia.toLowerCase().includes(searchHPT.toLowerCase())).slice(0, 8)
        // Si NO hay búsqueda: muestra los resultados que su fecha de planificación sea superior al día de hoy
        //: hpts.filter(h => h.fecha_prevista >= hoy).slice(0, 20);

    let hptsParaMostrar = [];

    if (searchHPT) {
        const busqueda = searchHPT.toLowerCase();
        let coincideFecha = false;
        // Filtrado de diferentes campos
        hptsParaMostrar = hpts.filter(h => {
            // Usamos ?. por si algún campo viene nulo o vacío de la base de datos
            const coincideOT = h.ot_referencia?.toLowerCase().includes(busqueda);
            const coincideTitulo = h.titulo?.toLowerCase().includes(busqueda);
            const coincideActivo = h.codigo_activo?.toLowerCase().includes(busqueda);
            const coincideNombre = h.nombre?.toLowerCase().includes(busqueda);
            const coincideGrupo = h.creador_grupo?.toLowerCase().includes(busqueda);
            const coincideLocalizacion = h.nombre_zona?.toLowerCase().includes(busqueda);
            const coincideRiesgos = h.riesgos_detallados?.some(item => 
                item.descripcion?.toLowerCase().includes(busqueda)
            );
            if (h.fecha_prevista) {
                const fechaFormateada = new Date(h.fecha_prevista).toLocaleDateString('es-ES');
                coincideFecha = fechaFormateada.includes(busqueda) || h.fecha_prevista.includes(busqueda);
            }
            const coincidenciaST = h.id_st?.toLowerCase().includes(busqueda);

            // Si tenemos alguna coincidencia se queda en lista
            return coincideOT || coincideTitulo || coincideActivo || coincideNombre || coincideGrupo || coincideFecha || coincideLocalizacion || coincideRiesgos || coincidenciaST;
        }).slice(0, 20);

    } else if (filterGroup) { // Filtrado por Departamento
        hptsParaMostrar = hpts.filter(h => {
            if (filterGroup === 'QUIMICO') return h.creador_grupo === 'QUIMICO' || h.creador_grupo === 'SPQuimico';
            if (filterGroup === 'MECANICO') return h.creador_grupo === 'MECANICO' || h.creador_grupo === 'SPMecanico';
            if (filterGroup === 'CAMPO SOLAR') return h.creador_grupo === 'CAMPO SOLAR' || h.creador_grupo === 'SPCampoSolar';
            if (filterGroup === 'ELECTRICOS') return h.creador_grupo === 'ELECTRICOS' || h.creador_grupo === 'SPElectrico';
            if (filterGroup === 'INSTRUMENTACION') return h.creador_grupo === 'INSTRUMENTACION' || h.creador_grupo === 'SPInstrumentacion';
            if (filterGroup === 'OPERACION') return h.creador_grupo === 'Operacion' || h.creador_grupo === 'OPERACION' || h.creador_grupo === 'JEFE_TURNO';
            return h.creador_grupo === filterGroup;
        });

    } else {
        // Si NO hay búsqueda: muestra los resultados que su fecha de planificación sea superior al día de hoy, máx 20
        hptsParaMostrar = hpts.filter(h => h.fecha_prevista >= hoy).slice(0, 20);
    }

    // ============================================================================
    // ALERTAS DINÁMICAS (Banner Superior)
    // ============================================================================
    // Busca si hay alguna HPT que le toque firmar que este pendiente
    const hptsPendientesMiFirma = hpts.filter(h => meTocaFirmar(h));

    // Configuración visual de los estados de un PTW
    const getStatusConfig = (estado) => {
        switch (estado) {
            case 'cerrado': return { icon: '🏁', color: '#d32f2f' }; // Rojo
            case 'abierto': return { icon: '🔓', color: '#2e7d32' }; // Verde
            case 'renovado': return { icon: '⏳', color: '#1a237e' };// Azul Oscuro
            default: return { icon: '📝', color: '#f57c00' };        // Naranja
        }
    };

    // ============================================================================
    // ACTUALIZAR CONTRASEÑA
    // ============================================================================
    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        setPassMsg({ error: '', success: '' });

        if (passwords.nueva !== passwords.confirmacion) {
            return setPassMsg({ error: 'Las contraseñas nuevas no coinciden.', success: '' });
        }
        if (passwords.nueva.length < 6) {
            return setPassMsg({ error: 'La contraseña debe tener al menos 6 caracteres.', success: '' });
        }

        try {
            // Mandamos los textos puros. ¡El servidor los encriptará con bcrypt!
            await cambiarPassword(uId, token, passwords.actual, passwords.nueva);

            // Éxito
            setPassMsg({ error: '', success: '¡Contraseña actualizada!' });
            setTimeout(() => {
                setShowChangePass(false);
                setPasswords({ actual: '', nueva: '', confirmacion: '' });
                setPassMsg({ error: '', success: '' });
            }, 2000);

        } catch (err) {
            setPassMsg({ 
                error: typeof err === 'string' ? err : 'Error al actualizar la contraseña.', 
                success: '' 
            });
        }
    };

    // ============================================================================
    // Mostrar y Actualizar Firma
    // ============================================================================
    // Funcion para obtener la firma
    const fetchFirmaUsuario = async () => {
        const token = localStorage.getItem('userToken');
        if (!uId) return;

        try {
            const res = await axios.get(`${API_URL}/auth/${uId}/firma`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.hasSignature) {
                setFirmaGuardada(res.data.firma_path);
            }
        } catch (error) {
            console.warn("No se pudo obtener la firma guardada");
        }
    };

    // Funcion para guardar la nueva firma
    const handleGuardarFirma = async (firmaBase64) => {
        setShowSignaturePad(false); // Cerramos el pad
        const token = localStorage.getItem('userToken');
        if (!uId) {
            Swal.fire('Error', 'No se ha podido identificar al usuario.', 'error');
            return;
        }

        try {
            await axios.post(`${API_URL}/auth/${uId}/firma`, {
                firma_path: firmaBase64
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setFirmaGuardada(firmaBase64); // Actualizamos la imagen en el desplegable
            
            Swal.fire({
                title: "¡Guardada!",
                text: "Tu firma maestra se ha actualizado correctamente.",
                icon: "success",
                confirmButtonColor: '#003366',
                timer: 2000
            });
        } catch (error) {
            Swal.fire('Error', 'No se pudo guardar la firma en el servidor.', 'error');
        }
    };

    // ============================================================================
    // Desglose por grupo
    // ============================================================================
    const desgloseHpts = hpts.reduce((acc, hpt) => {
        const grupo = hpt.creador_grupo;
        if (grupo) {
            acc[grupo] = (acc[grupo] || 0) + 1;
        }
        return acc;
    }, {});

    const desgloseHptsNuevas = hpts.reduce((acc, hpt) => {
        const grupo = hpt.creador_grupo;
        console.log(acc);
        
        // Si no hay grupo o no hay fecha, lo saltamos
        if (!grupo || !hpt.fecha_prevista || !hpt.dias_previstos) return acc;

        // Calculamos la fecha límite (Fecha prevista + días previstos)
        const fechaLimite = new Date(hpt.fecha_prevista);
        // Le restamos 1 para que si es "1 día", empiece y acabe mismo dia
        fechaLimite.setDate(fechaLimite.getDate() + (hpt.dias_previstos - 1));
        
        // Extraemos la fecha de hoy (solo YYYY-MM-DD)
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        fechaLimite.setHours(0, 0, 0, 0);

        // Comprobamos: Si la fecha límite es HOY o mas adelante la contamos
        if (fechaLimite >= hoy) {
            acc[grupo] = (acc[grupo] || 0) + 1;
        }
        return acc;
    }, {});

    // ============================================================================
    // Filtrar Por grupo
    // ============================================================================
    const handleFiltroRapido = (grupo) => {
        setFilterGroup(grupo);
        setSearchHPT('');
        setShowHptCounts(false);
    };

    // ============================================================================
    // 🎨 RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="dashboard-wrapper">
            {/* --- NAVBAR FIJO --- */}
            <nav className="navbar-main">
                {/* Menú de Creación (Hamburguesa Izquierda) */}
                <div className="nav-section" ref={menuRef}>
                    <button onClick={() => setMenuOpen(!menuOpen)} className="burger-btn">☰</button>
                    {menuOpen && (
                        <div className="dropdown-menu">
                            {['ADMINISTRADOR', 'GESTOR', 'JEFE_TURNO'].includes(userRol) && (
                                <div className="dropdown-item" onClick={() => navigate('/crear-ptw-directo', { state: { id_planta: plantaActiva } })}>
                                    ⚡ Nuevo permiso directo
                                </div>
                            )}
                            {['ADMINISTRADOR', 'PREVENCION', 'GESTOR', 'SUPERVISOR', 'JEFE_TURNO', 'OFICIAL'].includes(userRol) && (
                                <div className="dropdown-item" onClick={() => navigate('/crear-hpt', { state: { id_planta: plantaActiva } })}>
                                    📝 Nueva Planificación (HPT)
                                </div>
                            )}
                            <div className="dropdown-item" onClick={() => navigate('/planificador', { state: { id_planta: plantaActiva } })}>
                                🪛 Planificador
                            </div>
                        </div>
                    )}
                </div>
                
                {/* Título Central */}
                <div className="nav-center">
                    <span className="nav-title"> PLANTA 🏭 </span>
                    {perfilUsuario.plantas && perfilUsuario.plantas.length > 1 ? (
                        <select 
                            className="navbar-plant-selector"
                            value={plantaActiva} 
                            onChange={(e) => setPlantaActiva(e.target.value)}
                        >
                            {perfilUsuario.plantas.map(p => (
                                <option key={p.id_planta} value={p.id_planta}>
                                    {p.nombre}
                                </option>
                            ))}
                        </select>
                    ) : (
                        <span className="nav-title">
                            {perfilUsuario.plantas?.[0]?.nombre || 'Solares • GESTIONES HPT'} 
                        </span>
                    )}
                    <span className="nav-title"> • GESTIONES HPT </span>
                </div>
                
                {/* Menú de Usuario (Derecha) */}
                <div className="nav-section" ref={userRef}>
                    <div className="user-trigger" onClick={() => { 
                        setUserMenuOpen(!userMenuOpen); 
                        setShowProfile(false); // Resetea la vista al abrir/cerrar
                    }}>
                        <span>👤 {nameUser}</span>
                    </div>
                    
                    {userMenuOpen && (
                        <div className="context-menu profile-context-menu">
                            {!showProfile && !showChangePass && (
                                <>
                                    <div className="dropdown-item" onClick={(e) => { e.stopPropagation(); setShowChangePass(true); }}>
                                        🔑 Cambiar contraseña
                                    </div>
                                    <div className="dropdown-item" onClick={(e) => { e.stopPropagation(); setShowProfile(true); }}>
                                        👤 Perfil
                                    </div>
                                    <div className="dropdown-item danger" onClick={logout}>🚪 Cerrar Sesión</div>
                                </>
                            )}
                                {/* VISTA 2: PERFIL DE USUARIO */}
                                {showProfile && (
                                    <div className="profile-dropdown-panel">
                                        <div className="profile-header">
                                            <span className="back-btn" onClick={(e) => { e.stopPropagation(); setShowProfile(false); }}>⬅ Volver</span>
                                            <strong>Datos del Perfil</strong>
                                        </div>
                                        <div className="profile-body">
                                            <div className="profile-row"><span>Usuario:</span> <strong>{perfilUsuario.usuario}</strong></div>
                                            <div className="profile-row"><span>Nombre:</span> <strong>{perfilUsuario.nombre} {perfilUsuario.apellidos}</strong></div>
                                            <div className="profile-row"><span>Correo:</span> <strong>{perfilUsuario.correo}</strong></div>
                                            <div className="profile-row"><span>Rol:</span> <strong>{perfilUsuario.rol}</strong></div>
                                            <div className="profile-row"><span>Grupo:</span> <strong>{perfilUsuario.grupo}</strong></div>
                                            <div className="profile-row"><span>Asignaciones:</span> 
                                                <strong>
                                                    <ul>
                                                        {perfilUsuario.plantas.map(p =>(
                                                            <li key={p.id_planta}>{p.nombre}</li>
                                                        ))}
                                                    </ul>
                                                </strong>
                                            </div>
                                            {/* --- SECCIÓN DE FIRMA MAESTRA --- */}
                                            <hr className="profile-divider" />
                                            <div className="profile-signature-section">
                                                <span className="profile-signature-title">Mi Firma Digital Autorizada</span>
                                                
                                                {firmaGuardada ? (
                                                    <>
                                                        <div className="profile-signature-box">
                                                            <img src={firmaGuardada} alt="Firma Maestra" className="profile-signature-img" />
                                                        </div>
                                                        <button className="btn-profile-sign" onClick={(e) => { e.stopPropagation(); setShowSignaturePad(true); }}>
                                                            Modificar Firma
                                                        </button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="profile-signature-empty">Aún no has guardado una firma</span>
                                                        <button className="btn-profile-sign create" onClick={(e) => { e.stopPropagation(); setShowSignaturePad(true); }}>
                                                            ✍️ Crear Firma Maestra
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/* VISTA 3: CAMBIAR CONTRASEÑA */}
                                {showChangePass && (
                                    <div className="profile-dropdown-panel">
                                        <div className="profile-header">
                                            <span className="back-btn" onClick={(e) => { e.stopPropagation(); setShowChangePass(false); }}>⬅ Volver</span>
                                            <strong>Cambiar Contraseña</strong>
                                        </div>
                                        <div className="profile-body">
                                            <form onSubmit={handleUpdatePassword} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                <input type="password" required className="main-input" placeholder="Contraseña actual" 
                                                    value={passwords.actual} onChange={e => setPasswords({...passwords, actual: e.target.value})} 
                                                />
                                                <input type="password" required className="main-input" placeholder="Nueva contraseña" 
                                                    value={passwords.nueva} onChange={e => setPasswords({...passwords, nueva: e.target.value})} 
                                                />
                                                <input type="password" required className="main-input" placeholder="Repita nueva contraseña" 
                                                    value={passwords.confirmacion} onChange={e => setPasswords({...passwords, confirmacion: e.target.value})} 
                                                />
                                                
                                                {/* Mensajes de feedback */}
                                                {passMsg.error && <span style={{ color: '#d32f2f', fontSize: '11px', fontWeight: 'bold' }}>❌ {passMsg.error}</span>}
                                                {passMsg.success && <span style={{ color: '#2e7d32', fontSize: '11px', fontWeight: 'bold' }}>✅ {passMsg.success}</span>}
                                                
                                                <button type="submit" className="btn-save" style={{ padding: '8px', fontSize: '13px', marginTop: '5px' }}>
                                                    Actualizar
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                )}
                        </div>
                    )}
                </div>
            </nav>

            {/* --- BANNER DE ALERTAS --- */}
            {/* Solo se aplica si tiene alguna firma pendiente */}
            {hptsPendientesMiFirma.length > 0 && (
                <div className="alert-banner stacked">
                    {/* Fila principal del banner */}
                    <div className="d-flex align-center w-100 gap-10">
                        <span className="alert-icon">⚠️</span>
                        <div className="flex-1">
                            <strong>Atención: Tienes {hptsPendientesMiFirma.length} {hptsPendientesMiFirma.length === 1 ? 'firma pendiente' : 'firmas pendientes'} de tu rol.</strong>
                        </div>
                        
                        {/* Lógica del Botón Dinámico */}
                        <button 
                            className="btn-alert-action" 
                            onClick={() => {
                                if (hptsPendientesMiFirma.length === 1) {
                                    navigate(`/detalles-hpt/${hptsPendientesMiFirma[0].id_hpt}`);
                                } else {
                                    setShowPendingList(!showPendingList);
                                }
                            }}
                        >
                            {hptsPendientesMiFirma.length === 1 
                                ? 'Ir a firmar' 
                                : (showPendingList ? 'Ocultar lista 🔼' : 'Ver firmas pendientes 🔽')
                            }
                        </button>
                    </div>

                    {/* Mini lista desplegable (Solo si hay > 1 y se ha pulsado el botón) */}
                    {hptsPendientesMiFirma.length > 1 && showPendingList && (
                        <div className="mt-15 pending-list-container">
                            {hptsPendientesMiFirma.map(hpt => (
                                <div 
                                    key={hpt.id_hpt} 
                                    className="d-flex align-center justify-between pending-list-item" 
                                    onClick={() => navigate(`/detalles-hpt/${hpt.id_hpt}`)}
                                >
                                    <div>
                                        <strong className="pending-item-title">OT: {hpt.ot_referencia}</strong> <br/>
                                        <span className="pending-item-subtitle">
                                            ⚙️ {hpt.codigo_activo} - {hpt.den_act_descripcion}
                                        </span><br/>
                                        <span className="pending-item-subtitle"> 
                                            👤 {hpt.nombre} {hpt.apellidos}
                                        </span>
                                    </div>
                                    <div className="pending-item-action">
                                        FIRMAR →
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* --- CONTENIDO PRINCIPAL --- */}
            <div className="dashboard-content">
                
                {/* COLUMNA PTW (Comentada en el código original) */}
                {/*
                <div className="dash-column">
                    <div className="column-header">
                        <div className="d-flex align-center gap-10">
                            <span style={{fontSize: '20px'}}>📄</span>
                            <h3 className="col-title title-ptw">Ejecución (PTW)</h3>
                        </div>
                        <div className="counter-badge counter-ptw">
                            {ptwsNoCerradosCount} / {ptwsTotalCount} <span className="counter-small-text">ACTIVOS</span>
                        </div>
                    </div>
                    
                    <input 
                        type="text" 
                        placeholder="🔍 Buscar ID (historial completo)..." 
                        className="search-bar"
                        value={searchPTW}
                        onChange={(e) => setSearchPTW(e.target.value)}
                    />

                    <div className="card-list">
                        {ptwsParaMostrar.map(ptw => {
                            const config = getStatusConfig(ptw.estado);
                            return (
                                <div key={ptw.id_serial_interno} className="dash-card ptw-card">
                                    <div className="card-header-flex">
                                        <div className="id-badge ptw-id-badge">ID: {ptw.id_ptw_formato}</div>
                                        <span className="status-pill" style={{ backgroundColor: config.color }}>
                                            <span style={{ marginRight: '5px' }}>{config.icon}</span>
                                            {ptw.estado ? ptw.estado.toUpperCase() : 'CREADO'}
                                        </span>
                                    </div>

                                    <div className="asset-box">
                                        <div className="asset-row-flex">
                                            <span className="icon-circle-small">⚙️</span>
                                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                                <span className="asset-code-text">{ptw.codigo_activo || 'S/A'}</span>
                                                <span className="asset-name-text">{ptw.den_act_snapshot}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="scope-box">
                                        <p className="scope-text">
                                            <span style={{ marginRight: '8px' }}>🚧</span> 
                                            {ptw.alcance}
                                        </p>
                                    </div>

                                    <div className="card-footer-ptw">
                                        <div className="datetime-box">
                                            <span className="date-time-tag">📅 {ptw.fecha_trabajo ? new Date(ptw.fecha_trabajo).toLocaleDateString() : '--/--/--'}</span>
                                            <span className="date-time-tag">🕒 {ptw.rango_horario || 'S/H'}</span>
                                        </div>
                                        <button className="btn-manage-ptw" onClick={() => navigate(`/detalles-ptw/${ptw.id_serial_interno}`)}>
                                            GESTIONAR →
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                        {ptwsParaMostrar.length === 0 && <p className="empty-text-msg">No se encontraron resultados.</p>}
                    </div>
                </div> 
                */}

                {/* --- COLUMNA HPT --- */}
                <div className="dash-column">
                    <div className="column-header">
                        <div className="d-flex align-center gap-10">
                            <span style={{fontSize: '20px'}}>📋</span>
                            <h3 className="col-title title-hpt">Planificación (HPT)</h3>
                        </div>
                        {/* Conteo de HPTs atrasadas (menores de hoy) vs Total general */}
                        <div className="nav-section counter-wrapper" ref={counterHptRef}>
                            <div 
                                className="counter-badge counter-hpt counter-clickable" 
                                onClick={() => setShowHptCounts(!showHptCounts)}
                            >
                                {hptsNoFinalizadasCount} / {hptsTotalCount} <span className="counter-small-text">NUEVAS</span>
                            </div>

                            {/*DESPLEGABLE CON DESGLOSE POR DEPARTAMENTO*/}
                            {showHptCounts && (
                                <div className="dropdown-menu dropdown-stats">
                                    <strong className="dropdown-stats-title">
                                        DESGLOSE POR DEPARTAMENTO
                                    </strong>
                                    
                                    <div className="stats-list">
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('MECANICO')}>
                                            <span>⚙️ Mecánico:</span> <strong>{((desgloseHptsNuevas['MECANICO'] || 0) + (desgloseHptsNuevas['SPMecanico'] || 0))} / {((desgloseHpts['MECANICO'] || 0) + (desgloseHpts['SPMecanico'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('CAMPO SOLAR')}>
                                            <span>☀️ Campo Solar:</span> <strong>{((desgloseHptsNuevas['CAMPO SOLAR'] || 0) + (desgloseHptsNuevas['SPCampoSolar'] || 0))} / {((desgloseHpts['CAMPO SOLAR'] || 0) + (desgloseHpts['SPCampoSolar'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('ELECTRICOS')}>
                                            <span>⚡ Eléctricos:</span> <strong>{((desgloseHptsNuevas['ELECTRICOS'] || 0) + (desgloseHptsNuevas['SPElectrico'] || 0))} / {((desgloseHpts['ELECTRICOS'] || 0) + (desgloseHpts['SPElectrico'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('INSTRUMENTACION')}>
                                            <span>🎛️ Instrumentación:</span> <strong>{((desgloseHptsNuevas['INSTRUMENTACION'] || 0) + (desgloseHptsNuevas['SPInstrumentacion'] || 0))} / {((desgloseHpts['INSTRUMENTACION'] || 0) + (desgloseHpts['SPInstrumentacion'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('QUIMICO')}>
                                            <span>🧪 Químico:</span> <strong>{((desgloseHptsNuevas['QUIMICO'] || 0) + (desgloseHptsNuevas['SPQuimico'] || 0))} / {((desgloseHpts['QUIMICO'] || 0) + (desgloseHpts['SPQuimico'] || 0))}</strong>
                                        </div>
                                        <div className="stats-row stats-row-clickable" onClick={() => handleFiltroRapido('OPERACION')}>
                                            <span>🏭 Operación:</span> <strong>{desgloseHptsNuevas['OPERACION'] || 0}/{desgloseHpts['OPERACION'] || 0}</strong>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                   {/* Buscador inteligente */}
                    <input 
                        type="text" 
                        placeholder="🔍 Buscar OT (historial completo)..." 
                        className="search-bar"
                        value={searchHPT}
                        onChange={(e) => {
                            setSearchHPT(e.target.value);
                            setFilterGroup('');
                        }}
                    />
                    {filterGroup && (
                        <div className='filter-departament'>
                            <span className="id-badge">
                                Filtrando por: <strong>{filterGroup}</strong> 
                                <button 
                                    onClick={() => setFilterGroup('')} 
                                >
                                    ✕
                                </button>
                            </span>
                        </div>
                    )}


                    {/* Lista de Tarjetas HPT */}
                    <div className="card-list">
                        {hptsParaMostrar.map(hpt => (
                            // El borde izquierdo se pinta ROJO fuerte si al usuario le toca firmar.
                            <div 
                                key={hpt.id_hpt} 
                                className={`dash-card hpt-card ${(hpt.pendiente_de === 'COMPLETO' && hpt.fecha_prevista > hoy)  ? 'signature-finish' : meTocaFirmar(hpt) ? 'requires-signature' : '' }`}
                            >
                                <div className="card-header-flex">
                                    <div className="id-badge hpt-ot-badge">OT: {hpt.ot_referencia}</div>
                                    
                                    {/* Etiqueta de estado dinámica */}
                                    <div className="d-flex align-center">
                                        <span className={`status-pill ${hpt.pendiente_de === 'COMPLETO' ? 'complete' : 'waiting'}`}>
                                            {(hpt.pendiente_de === 'COMPLETO' && hpt.fecha_prevista > hoy) ? '✍️ PLANIFICACIÓN COMPLETADA' : `⏳ ESPERA: ${hpt.pendiente_de}`}
                                        </span>
                                        
                                        {/* Botón de borrar solo para GESTOR o ADMINISTRADOR */}
                                        {(userRol === 'ADMINISTRADOR' || userRol === 'GESTOR') && (
                                            <button 
                                                className="btn-delete-dash" 
                                                title="Eliminar Planificación"
                                                onClick={(e) => { 
                                                    e.stopPropagation(); 
                                                    handleDeleteHPT(hpt.id_hpt, hpt.ot_referencia); 
                                                }}
                                            >
                                                ✖
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {/* INFO ACTIVO HPT */}
                                <div className="asset-box">
                                    <div className="asset-row-flex">
                                        <span className="icon-circle-small">📃</span>
                                        <div className="asset-info-wrapper">
                                            <span className="asset-name-text">
                                                🪧 {hpt.titulo}
                                            </span>
                                            <span className="asset-code-text">
                                                🏷️ {hpt.codigo_activo || 'S/A'}
                                            </span>
                                            <span className="asset-name-text">
                                                ⚙️ {hpt.den_act_descripcion}
                                            </span>
                                            <span className="asset-loc-tag">
                                                📍 {hpt.nombre_zona || 'Planta General'}
                                            </span>
                                            <span className="asset-loc-tag">
                                                👤 {hpt.nombre + " " + hpt.apellidos + " " + hpt.creador_grupo || ''}
                                            </span>
                                            <span className="asset-desc_tag">
                                                👷 {hpt.descripcion_trabajo ? hpt.descripcion_trabajo.split('.')[0] : ''}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Botón de entrada a Detalles HPT */}
                                <div className="card-footer-hpt">
                                    <div className='asset-info-date'>📅 {hpt.fecha_prevista} ➡️ (⏳{hpt.dias_previstos} {hpt.dias_previstos > 1 ? "Días" :"Día"})</div>
                                    <button className="btn-view-hpt" onClick={() => navigate(`/detalles-hpt/${hpt.id_hpt}`)}>
                                        VER DETALLES
                                    </button>
                                </div>
                            </div>
                        ))}
                        {/* Mensaje de vacío si no hay resultados en el array */}
                        {hptsParaMostrar.length === 0 && <p className="empty-text-msg">No se encontraron resultados.</p>}
                    </div>
                </div>
                
            </div>
            {showSignaturePad && (
                <SignaturePad 
                    onSave={handleGuardarFirma} 
                    onCancel={() => setShowSignaturePad(false)} 
                />
            )}
        </div>
    );
};

export default DashboardScreen;